"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$remarks = exports.remarksToLines = exports.remarksLabelPtn = exports.remarksControl = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const _paragraphItem_1 = __importStar(require("./$paragraphItem"));
const inline_1 = require("../../../node/cst/inline");
const util_2 = require("../../../util");
const _sentenceChildren_1 = require("../../cst/rules/$sentenceChildren");
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
const el_1 = require("../../../node/el");
const _otherLine_1 = require("../../cst/rules/$otherLine");
const parse_1 = __importDefault(require("../../cst/parse"));
const util_3 = require("../../cst/util");
const controls_1 = require("../../../node/el/controls");
exports.remarksControl = ":remarks:";
exports.remarksLabelPtn = /^(?:備\s*考|注)\s*$/;
/**
 * The renderer for {@link std.Remarks}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$remarks.spec.ts) for examples.
 */
const remarksToLines = (remarks, indentTexts) => {
    const lines = [];
    const remarksLabel = remarks.children.find(el => el.tag === "RemarksLabel");
    const remarksLabelSentenceChildren = remarksLabel?.children;
    const controls = remarksLabelSentenceChildren && exports.remarksLabelPtn.exec((0, _sentenceChildren_1.sentenceChildrenToString)(remarksLabelSentenceChildren)) ? [] : [
        new inline_1.Control(exports.remarksControl, null, "", null),
    ];
    const remarksLabelSentences = new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, remarksLabelSentenceChildren)]);
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls,
        sentencesArray: remarksLabelSentenceChildren ? [remarksLabelSentences] : [],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    if (remarksLabel) {
        for (const [name, value] of Object.entries(remarksLabel.attr)) {
            if (std.defaultAttrs[remarksLabel.tag][name] === value)
                continue;
            remarksLabelSentences.attrEntries.push(new inline_1.AttrEntry(`[${name}="${value}"]`, [name, value], null, "", null));
        }
    }
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    const restChildren = remarks.children.filter(c => c.tag !== "RemarksLabel");
    for (const child of restChildren) {
        if (child.tag === "Sentence") {
            const line = new line_1.OtherLine({
                range: null,
                indentTexts: childrenIndentTexts,
                controls: [],
                sentencesArray: [
                    new inline_1.Sentences("", null, [], [child]),
                ],
                lineEndText: toCSTSettings_1.default.EOL,
            });
            const lineText = (0, _sentencesArray_1.sentencesArrayToString)(line.sentencesArray);
            try {
                const parsedLines = (0, parse_1.default)(lineText);
                if (parsedLines.value[0].type !== line_1.LineType.OTH) {
                    line.controls.push(new inline_1.Control(_otherLine_1.ignoreTitleControl, null, "", null));
                }
            }
            catch {
                //
            }
            // eslint-disable-next-line no-irregular-whitespace
            if (/^[ 　\t]+/.test(child.text())) {
                line.controls.push(new inline_1.Control(_otherLine_1.keepLeadingSpacesControl, null, "", null));
            }
            lines.push(line);
        }
        else if (child.tag === "Item") {
            const itemLines = (0, _paragraphItem_1.paragraphItemToLines)(child, childrenIndentTexts, { defaultTag: "Item" });
            lines.push(...itemLines);
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.remarksToLines = remarksToLines;
const $remarksChildrenBlock = (0, util_1.makeIndentBlockWithCaptureRule)("$remarksChildrenBlock", (factory_1.factory
    .choice(c => c
    .orSequence(s => s
    .and(() => (0, _paragraphItem_1.default)("Item"), "paragraphItem")
    .andOmit(r => r.assert(({ paragraphItem }) => std.isItem(paragraphItem.value)))
    .action(({ paragraphItem }) => {
    return {
        value: [paragraphItem.value],
        errors: paragraphItem.errors,
    };
}))
    .or(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.sentencesArray.length > 0) {
        const sentenceChildren = [];
        for (const sentences of item.line.sentencesArray) {
            sentenceChildren.push(new controls_1.__Text(sentences.leadingSpace, sentences.leadingSpaceRange));
            for (const sentence of sentences.sentences) {
                sentenceChildren.push(...sentence.children);
            }
        }
        const sentence = (0, std_1.newStdEL)("Sentence", (0, util_2.omit)(item.line.sentencesArray[0].sentences[0].attr, "Function", "Num"), (0, util_3.mergeAdjacentTextsWithString)(sentenceChildren), item.line.sentencesArrayRange);
        return {
            value: [sentence],
            errors: [],
        };
    }
    else {
        return null;
    }
})))));
/**
 * The parser rule for {@link std.Remarks}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$remarks.spec.ts) for examples.
 */
exports.$remarks = factory_1.factory
    .withName("remarks")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && ((item.line.controls.some(c => c.control === exports.remarksControl))
            || (item.line.sentencesArray.length > 0
                && exports.remarksLabelPtn.exec((0, _sentencesArray_1.sentencesArrayToString)(item.line.sentencesArray, {
                    withoutAttrs: true,
                }))))) {
        return item;
    }
    else {
        return null;
    }
}), "labelLine")
    .and(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(() => $remarksChildrenBlock, "childrenBlock")
    .action(({ labelLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    const remarksLabelSentenceChildren = (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(labelLine.line.sentencesArray);
    const attrEntries = labelLine.line.sentencesArray[0]?.attrEntries ?? [];
    const remarksLabel = ((remarksLabelSentenceChildren.length > 0) || attrEntries.length > 0) ? (0, std_1.newStdEL)("RemarksLabel", Object.fromEntries(attrEntries.map(attrEntry => attrEntry.entry)), remarksLabelSentenceChildren, labelLine.line.sentencesArrayRange) : null;
    if (remarksLabel) {
        children.push(remarksLabel);
    }
    children.push(...childrenBlock.value.flat().map(v => v.value).flat());
    errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
    errors.push(...childrenBlock.errors);
    const pos = labelLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const remarks = (0, std_1.newStdEL)("Remarks", {}, children, range);
    return {
        value: remarks,
        errors,
    };
}));
exports.default = exports.$remarks;
//# sourceMappingURL=$remarks.js.map